import React, { useEffect, useState } from 'react';
import { aggregateBetsForPlayer } from '../data/utils/aggregateBetsForPlayer';
import { getBetDescription } from '../data/utils/getBetDescription';
import { lowerCaseStringCompare } from '../data/utils/lowerCaseStringCompare';
import { useGetOffsetClass } from '../utils/useGetOffsetClass';
import CashoutLabel from './CashoutLabel';
import { useJerseyData } from './JerseyProvider';
import Jersey from '../data/jerseys/Jersey';
import OddNoDesc from './OddNoDesc';
import { getEventUrl } from '../utils/getEventUrl';
import XRouterLink from './seo/xrouter/XRouterLink';
import ListBetFilters from './ListBetFilters';
import { splitHandicap } from '../data/splitHandicap';
import { getLabel } from '../data/labels';
import FavoriteButtonMarket from './favorite-markets/FavoriteButtonMarket';

function getFirstLine(bets) {
    let bet = bets[0];
    for (let i = 0; i < bets.length; i++) {
        if (bets[i]?.mainLine > 0 && bets[i].mainLine === bets[i].handicap) {
            bet = bets[i];
            break;
        }
    }
    return bet;
}

function processBets(bets) {
    const dia = bets[0].dia?.replaceAll("$", " ");
    const regex = /(?<player1>.+) \((?<team>.+)\) (?<player2>.+) \(\k<team>\)/;
    if (regex.test(dia)) {
        bets.forEach(b => {
        	const dia = b.dia?.replaceAll("$", " ");
            const result = regex.exec(dia);
            if (result != null) {
                const groups = result.groups;
                b.baseDesc = dia;
                b.team = groups.team;
                b.player1 = groups.player1;
                b.player2 = groups.player2;
            }
        });
    } else {
        bets.forEach(b => {
            b.baseDesc = b.desc;
            const dia = b.dia?.replaceAll("$", " ");
            if (dia?.includes('(')) {
                const parts = b.dia.split(' (');
                if(parts.length === 2){
	                b.baseDesc = parts[0];
	                b.team = parts[1].slice(0, -1);                
                }
                else if(parts.length === 3){
                	// ripetizione del team nel caso di 2 giocatori es 'Bastoni Alessandro (Inter) Dimarco Federico (Inter)'
                	let team = '';
                	for(let kp in parts){
                		if(parts[kp].includes(')')){
                			team = parts[kp].split(")")[0];
                			break;
                		}
                	}
                	if(team !== ''){
                		b.team = team;
                		// rimuovo il team e la parantesi dalla descrizione
                		b.baseDesc = b.baseDesc.replaceAll("(" + team + ")", "");
                	}
                }
            }
        });
    }

    if (bets[0].dia) {
        bets.sort((a, b) => {
        	if(a.id != b.id){
        		return 0;
        	}
        	if(!a.dia){
        		return 1; // b viene prima se a non ha dia
        	}
        	if(!b.dia){
        		return -1; // a viene prima se b non ha dia
        	}
        	return a.dia.localeCompare(b.dia);
        });
    }

    return bets;
}

function OddSelector(props) {
    const odds = props.odds;
    const [odd, setOdd] = useState(props.odds[0]);
    const [toggled, setToggled] = useState(false);

    function openDropdown() {
        if (odds.length === 1) {
            return;
        }

        setToggled(!toggled);
    }

    function changeOdd(odd) {
        setOdd(odd);
        setToggled(false);
    }

    const selected = odds.find(o => o.uniqueId === odd.uniqueId);
    let desc = null;
    if (selected.betData.tipoHandicap === 35) {
        const hcp = splitHandicap(selected.betData.handicap, selected.betData.tipoHandicap).info2;
        desc = `${selected.desc} ${hcp}`;
    } else {
        desc = selected.descForBetsAggregate || selected.desc;
    }
    
    return (
        <div className="flex items-start xs_scorerMarket--odds">
            <div className="relative flex flex-col mr-1 w-full">
                <div className="px-1 grid grid-cols-12 items-center justify-between border border-cs7 rounded-lg" onClick={openDropdown}>
                    <span className="col-start-1 col-end-12 py-2 font-medium text-xs break-words">{desc}</span>
                    {odds.length > 1 &&                
                        <i className="col-start-12 col-end-13 justify-self-center xs-font-icon bi-chevron-expand" />
                    }
                </div>
                {toggled && 
                    <div className="max-h-[200px] overflow-y-auto mt-1 bg-cs1 border border-cs7 rounded-lg">
                        {odds.map(o => {
                            let classes = o.uniqueId === selected.uniqueId ? 'bg-cs4 text-cs1 first:rounded-t-md last:rounded-b-md' : 'text-cs6';
                            if (o.betData.pClass != null) {
                                classes += ` ${o.betData.pClass}`;
                            }
                            let desc = null;
                            if (o.betData.tipoHandicap === 35) {
                                const hcp = splitHandicap(o.betData.handicap, o.betData.tipoHandicap).info2;
                                desc = `${o.desc} ${hcp}`;
                            } else {
                                desc = o.descForBetsAggregate || o.desc;
                            }
                            return (
                                <div key={o.uniqueId} className={`xs_odd relative p-2 flex items-center justify-between font-medium text-xs ${classes}`} onClick={() => changeOdd(o)}>
                                    <span>{desc}</span>
                                    <span>{o.value}</span>
                                </div>
                            );
                        })}
                    </div>
                }
            </div>
            <OddNoDesc isBetBuilder={props.isBetBuilder} data={selected} hideDesc={true} />
        </div>
    );
}

function Bets(props) {
    const jData = useJerseyData();

    return (
        <>
            {props.bets.map(b => {
                const odds = b.odds.filter(o => o.value != null);

                if (odds.length === 0) {
                    return null;
                }

                return (
                    <div key={b.uniqueId} className={`w-full px-2 py-1 flex items-start justify-items-center border border-cs16 border-b-0`}>
                        <div className="w-full flex items-center justify-start">
                            {lowerCaseStringCompare(jData?.home, b.team) && jData.jerseys?.[0] &&
                                <Jersey data={jData.jerseys?.[0]} type={'home'} sportRef={jData.sportRef} />
                            }
                            {lowerCaseStringCompare(jData?.away, b.team) && jData.jerseys?.[1] &&
                                <Jersey data={jData.jerseys?.[1]} type={'away'} sportRef={jData.sportRef} />
                            }
                            {b.team ?
                                <>
                                    {b.player1 ?
                                        <div className="flex flex-col justify-self-start">
                                            <div className="text-sm justify-self-start">{b.player1}</div>
                                            <div className="text-sm justify-self-start">{b.player2}</div>
                                            <div className="text-xs text-cs9 justify-self-start">{b.team}</div>
                                        </div>
                                        :
                                        <div className="flex flex-col justify-self-start">
                                            <div className="text-sm justify-self-start">{b.baseDesc}</div>
                                            <div className="text-xs text-cs9 justify-self-start">{b.team}</div>
                                        </div>
                                    }
                                </>
                                :
                                <div className="text-sm justify-self-start">{b.baseDesc}</div>
                            }
                            {props.showFavoriteMarkets && 
                                <FavoriteButtonMarket className={'flex flex-col justify-self-start'} bet={b}  />
                            }
                        </div>
                        
                        <div className="w-full">
                            <OddSelector isBetBuilder={props.isBetBuilder} key={b.uniqueId} odds={odds} />
                        </div>
                    </div>
                );
            })}
        </>
    );
}

function BetsContainer(props) {
    const [toggled, setToggled] = useState(false);

    const bets = props.bets;
    const first = bets.slice(0, 6);
    const other = bets.slice(6);

    return (
        <>
            <Bets bets={first} showFavoriteMarkets={props.showFavoriteMarkets} isBetBuilder={props.isBetBuilder} />
            {toggled &&
                <Bets bets={other} showFavoriteMarkets={props.showFavoriteMarkets} isBetBuilder={props.isBetBuilder} />
            }
            {other.length > 0 &&
                <div className="w-full py-2 flex items-center justify-center text-xs border-t border-t-cs16 " onClick={() => setToggled(prev => !prev)}>
                    {toggled ?
                        <>
                            {getLabel('show_less')}
                            <i className="ml-1 bi-chevron-up" />
                        </>
                        :
                        <>
                            {getLabel('show_more')}
                            <i className="ml-1 bi-chevron-down" />
                        </>
                    }
                </div>
            }
        </>
    );
}

function ListBetSelectorInner(props) {
    const jData = useJerseyData();
    const [filter, setFilter] = useState(null);
    function changeFilter(f) {
        setFilter(f);
    }

    let bets = props.bets;
    if ([6, 35, 38].includes(bets[0].tipoHandicap)) {
        bets = aggregateBetsForPlayer(bets, bets[0].tipoHandicap);
    }
    bets = processBets(bets);

    let betsToShow = bets;
    if (filter != null) {
        betsToShow = betsToShow.filter(s => {
            const teamDesc = s.team.toLowerCase();
            const homeTeam = jData.home.toLowerCase();
            const awayTeam = jData.away.toLowerCase();
            if ((teamDesc === homeTeam && filter === 'home') || (teamDesc === awayTeam && filter === 'away')) {
                return true;
            }
            return false;
        });
    }
    
    return (
        <>
            {bets[0].team != null &&
                <div className="px-2 py-1 w-full grid grid-cols-2 bg-cs7 text-cs6">
                    <ListBetFilters filter={filter} changeFilter={changeFilter} />
                </div>
            }
            <BetsContainer bets={betsToShow} isBetBuilder={props.isBetBuilder} showFavoriteMarkets={props.showFavoriteMarkets} />
        </>
    );
}

export default function ListBetSelector(props) {
    const [toggled, setToggled] = useState(props.startToggled);

    useEffect(() => {
        if (props.toggle != null && props.toggle !== toggled) {
            setToggled(props.toggle);
        }
    }, [props.toggle]);
    
    const bets = props.bets;
    const firstBet = bets[0];
    const desc = getBetDescription(firstBet, true);
    
    return (
        <>
            <div className="xs_bet flex flex-col">
                <div className="min-h-[40px] grid grid-cols-11 justify-items-center items-center border-b border-b-cs1" onClick={() => setToggled(!toggled)}>
                    <div className="w-full col-start-1 col-end-11 pl-2 flex shrink-0 items-center justify-between">
                        <span className="font-bold text-sm text-cs3 uppercase">{desc}</span>
                        <CashoutLabel bet={firstBet} />
                    </div>
                    <div className="w-full col-start-11 col-end-12 flex items-center justify-center font-medium text-md text-cs3">
                        {toggled ?
                            <i className="bi-chevron-up"></i>
                            :
                            <i className="bi-chevron-down"></i>
                        }
                    </div>
                </div>
                {toggled &&
                    <ListBetSelectorInner bets={bets} isBetBuilder={props.isBetBuilder} showFavoriteMarkets={props.showFavoriteMarkets} />
                }
            </div>
        </>
    );
}

export function ListBetSelectorAlt(props) {
    const e = props.event;
    const offsetClass = useGetOffsetClass();

    return (
        <div className="xs_scorerMarket">
            <div className={`xs_dateHeader sticky ${offsetClass}`}>
                <div className="p-2 flex items-center justify-between bg-cs7 text-cs6">
                    <XRouterLink to={getEventUrl(e)} data={e} state={e} className="font-medium text-sm">{e.team1} v {e.team2}</XRouterLink>
                    <span className="text-sm">{e.date}</span>
                </div>
            </div>
            <ListBetSelectorInner bets={props.bets} />
        </div>
    );
}
